import View from './view'

const AutoConnectNewProjectsSwitch = View

export default AutoConnectNewProjectsSwitch